<template>
	<div class="profile-dropdown col-2 nav-item dropdown navbar-dropdown" v-dropdown>
		<a class="nav-link dropdown-toggle truncate" href="#">
			<slot name="profile-name"></slot>
		</a>
		<div class="dropdown-menu last">
			<div class="dropdown-menu-content">
				
				<!-- <div class="dropdown-item plain-link-item">
					<a href="#" class="plain-link"> {{ 'user.profile' | translate}} </a>
				</div> -->

				<div class="dropdown-item plain-link-item"  @click.stop="logout()">
					<a href="#" class="plain-link"> {{ 'user.logout' | translate}} </a>
				</div>

			</div>
		</div>
	</div>
</template>

<script>

	import { globalStore } from '@/services/userService'

	export default {
		name: 'profile-section',
		props: {
		},
		methods : {
			logout(){
				globalStore.clearToken();
				globalStore.clearUser();
				localStorage.setItem('adblock-warning', false);
				this.$router.push({ name: 'login' });
			}
		}
	}
</script>

<style lang="scss">
	.profile-dropdown {
		flex: 1 1 0;
		&.navbar-dropdown{
			justify-content: flex-end !important;
		}
		.profile-section-avatar-container {
			display: inline-block;
			width: 50px;
			height: 50px;
			background-color: white;
			border-radius: 50%;
			border: 2px solid $lighter-gray;
			overflow: hidden;

			img {
				height: 100%;
				width: 100%;
			}
		}

	}

</style>



// WEBPACK FOOTER //
// src/components/admin/app-navbar/components/dropdowns/ProfileDropdown.vue